function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M437.836,22.068h-99.553c-5.534,0-10.022,4.488-10.022,10.022s4.488,10.022,10.022,10.022h99.553 c29.841,0,54.12,24.279,54.12,54.12v168.372c0,29.841-24.279,54.12-54.12,54.12h-58.767c-2.648,0-5.186,1.047-7.065,2.912 l-40.403,40.149v-33.039c0-5.534-4.488-10.022-10.022-10.022H165.234c-29.841,0-54.12-24.279-54.12-54.12V96.232 c0-29.841,24.279-54.12,54.12-54.12h95.544c5.534,0,10.022-4.488,10.022-10.022s-4.488-10.022-10.022-10.022h-95.544 c-40.894,0-74.164,33.269-74.164,74.164v9.867H74.164C33.269,106.099,0,139.368,0,180.263v178.383 c0,40.894,33.269,74.164,74.164,74.164h54.635l54.559,54.214c1.915,1.902,4.469,2.912,7.067,2.912c1.297,0,2.605-0.252,3.848-0.77 c3.737-1.554,6.172-5.204,6.172-9.252V432.81h146.323c40.894,0,74.164-33.269,74.164-74.164v-19.878h16.906 c40.894,0,74.164-33.269,74.164-74.164V96.232C512,55.338,478.731,22.068,437.836,22.068z M400.886,358.646 c0,29.841-24.279,54.12-54.12,54.12H190.421c-5.534,0-10.022,4.488-10.022,10.022v33.039l-40.403-40.149 c-1.878-1.865-4.417-2.912-7.065-2.912H74.164c-2.033,0-4.038-0.122-6.013-0.342V352.78c0-5.534-4.488-10.022-10.022-10.022 s-10.022,4.488-10.022,10.022v53.281c-16.713-9.221-28.062-27.016-28.062-47.416V180.263c0-29.841,24.279-54.12,54.12-54.12H91.07 v138.461c0,40.894,33.269,74.164,74.164,74.164h146.323v47.104c0,4.048,2.435,7.699,6.172,9.252c1.245,0.518,2.552,0.77,3.849,0.77 c2.598,0,5.151-1.01,7.067-2.912l54.559-54.214h17.683V358.646z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M301.535,42.11c2.636,0,5.222-1.063,7.085-2.937c1.864-1.863,2.938-4.449,2.938-7.085c0-2.636-1.072-5.222-2.938-7.086 c-1.863-1.864-4.44-2.936-7.085-2.936c-2.636,0-5.222,1.071-7.086,2.936s-2.936,4.45-2.936,7.086c0,2.636,1.071,5.222,2.936,7.085 C296.314,41.047,298.899,42.11,301.535,42.11z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M239.14,245.595c1.158,0.434,2.344,0.639,3.512,0.639c4.06,0,7.88-2.484,9.388-6.511l14.824-39.594h35.632l14.825,39.595 c1.94,5.181,7.71,7.812,12.901,5.871c5.183-1.941,7.812-7.716,5.871-12.9l-42.027-112.248c-1.465-3.914-5.207-6.507-9.386-6.507 c-4.179,0-7.92,2.594-9.386,6.508l-42.026,112.248C231.327,237.879,233.956,243.655,239.14,245.595z M284.68,152.544l10.312,27.54 h-20.623L284.68,152.544z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M437.497,154.299c0-22.254-18.105-40.36-40.36-40.36s-40.36,18.105-40.36,40.36v51.572c0,22.255,18.105,40.36,40.36,40.36 c8.302,0,16.026-2.523,22.45-6.838l3.89,3.897c1.957,1.96,4.525,2.941,7.093,2.941c2.563,0,5.124-0.977,7.081-2.929 c3.917-3.911,3.923-10.256,0.012-14.174l-4.698-4.707c2.889-5.558,4.533-11.864,4.533-18.55L437.497,154.299L437.497,154.299z  M410.418,201.835c-3.91-3.916-10.256-3.921-14.174-0.012c-3.917,3.911-3.923,10.256-0.012,14.174l8.637,8.652 c-2.385,0.985-4.994,1.537-7.731,1.537c-11.203,0-20.316-9.114-20.316-20.316v-51.572c0-11.202,9.114-20.316,20.316-20.316 c11.202,0,20.316,9.114,20.316,20.316v51.572c0,0.951-0.088,1.88-0.215,2.797L410.418,201.835z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M178.99,133.983h30.071c5.534,0,10.022-4.488,10.022-10.022s-4.488-10.022-10.022-10.022H178.99 c-13.526,0-24.53,11.017-24.53,24.559v97.711c0,5.534,4.488,10.022,10.022,10.022c5.534,0,10.022-4.488,10.022-10.022v-36.081 h34.556c5.534,0,10.022-4.488,10.022-10.022s-4.488-10.022-10.022-10.022h-34.556v-41.586 C174.505,136.009,176.517,133.983,178.99,133.983z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M58.127,305.171c-2.636,0-5.222,1.072-7.086,2.938c-1.863,1.863-2.936,4.449-2.936,7.085c0,2.636,1.072,5.222,2.936,7.086 c1.864,1.864,4.45,2.936,7.086,2.936c2.636,0,5.222-1.071,7.086-2.936c1.863-1.864,2.936-4.45,2.936-7.086 c0-2.636-1.072-5.222-2.936-7.085C63.349,306.243,60.763,305.171,58.127,305.171z"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF0AA"
    },
    d: "M68.949,210.699v199.077c0,4.397,0.418,8.693,1.177,12.871c1.336,0.083,2.68,0.139,4.038,0.139 h58.767l57.49,57.126v-57.126h156.345c35.424,0,64.142-28.717,64.142-64.142V180.263c0-15.663-5.621-30.008-14.947-41.147H140.532 C100.998,139.117,68.949,171.165,68.949,210.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M180.366,134.96c0-39.667,32.156-71.823,71.823-71.823h240.597 c-11.23-18.604-31.635-31.047-54.95-31.047H165.234c-35.424,0-64.142,28.717-64.142,64.142v168.372 c0,35.424,28.717,64.142,64.142,64.142h15.345c-0.125-1.736-0.211-3.484-0.211-5.252L180.366,134.96L180.366,134.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91E696"
    },
    d: "M321.579,385.872l57.49-57.126h58.767c35.424,0,64.142-28.717,64.142-64.142V96.232 c0-12.11-3.359-23.433-9.191-33.095H252.189c-39.667,0-71.823,32.156-71.823,71.823v188.535c0,1.768,0.086,3.516,0.211,5.252h141 v57.125H321.579z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.ec2d6742.svg";
export { ForwardRef as ReactComponent };